import { render, staticRenderFns } from "./ChildCard.vue?vue&type=template&id=72ec3f0d&"
import script from "./ChildCard.vue?vue&type=script&lang=js&"
export * from "./ChildCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports